import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const Vision = () => {
  return (
    <Box margin={{ xs: "25% 0% 15% 0%", sm: "10% 0% 10% 0%" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box
          width={{ xs: "100%", sm: "48%" }}
          paddingRight={{ xs: "0%", sm: "4%" }}
        >
          <Typography
            variant="h3"
            fontWeight={700}
            paddingBottom={{ xs: "4%", sm: "4%" }}
            textAlign={"left"}
            color={"#317ABE"}
          >
            {" "}
            Our Vision
          </Typography>
          <Typography
            fontSize={"1.1rem"}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
            color={"#000"}
          >
            {" "}
            A resilient Nigeria where healthy marine and coastal ecosystems
            sustain thriving communities, inclusive blue economies, and
            climate-secure livelihoods for present and future generations.
          </Typography>
        </Box>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          color={"#9DCC49"}
          width={4}
        />
        <Box
          width={{ xs: "100%", sm: "48%" }}
          paddingLeft={{ xs: "0%", sm: "4%" }}
          paddingTop={{ xs: "25%", sm: "0%" }}
        >
          <Typography
            variant="h3"
            fontWeight={700}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
            color={"#317ABE"}
          >
            {" "}
            Our Mission
          </Typography>
          <Typography
            variant="body1"
            fontWeight={400}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
            color={"#000"}
          >
            {" "}
            To restore, protect, and sustainably manage Nigeria’s marine,
            mangrove, and coastal ecosystems by delivering science-based,
            community-led, and climate-smart solutions that strengthen blue
            livelihoods, advance policy and innovation, and build long-term
            resilience for people and nature.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Vision;
